import { useEffect } from 'react';

const IPTracker = () => {
  useEffect(() => {
    const trackIP = async () => {
      try {
        await fetch('https://uzidev-priv.onrender.com/api/track-ip');
      } catch (error) {
        console.error('Error tracking IP:', error);
      }
    };

    trackIP();
  }, []);

  return null; // This component doesn't render anything
};

export default IPTracker; 